import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { MenuItem } from '@common/generic/models/MenuItem';
import { AuthService } from '@common/generic/services/auth.service';
import { ProfileService } from '@common/generic/services/profile.service';
import {NavigationEnd, Router} from '@angular/router';
import {Profile} from '@common/generic';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  @Input()
  visible: boolean;
  isSubMenuVisible: boolean;

  @Input()
  menuItems: MenuItem[];
  @Input()
  activeMenuItems: MenuItem[];
  @HostBinding('class.active')
  active = false;

  hasVisibleEntries = false;

  constructor(private authService: AuthService, private profileService: ProfileService, private router: Router) {
    this.isSubMenuVisible = false;
  }

  ngOnInit() {
    this.applyPermissions();
    this.profileService.currentProfile.subscribe(profile => {
      this.applyPermissions();
    });
  }

  private applyPermissions() {
    this.menuItems.forEach(menuItem => {
      menuItem.visible = true;
      menuItem.visible = this.authService.inRole(menuItem.roles);
      if (menuItem.visible) {
        this.hasVisibleEntries = true;
      }
    });
    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (e.url !== '/account/login') {
          this.visible = true;
        }
      }
    });
    this.activeMenuItems = this.menuItems.filter(menuItem => menuItem.visible);
  }

  toggleActive(menu) {
    if (menu === 'Reports') {
      this.isSubMenuVisible = !this.isSubMenuVisible;
    } else {
      this.active = !this.active;
      if (this.isSubMenuVisible) {
        this.isSubMenuVisible = !this.isSubMenuVisible;
      }
    }
  }
}
